import {
    postData,
    patchData,
    getDataWithParams,
    destroyData,
    getData
} from '@/store/config/method'
const initialState = () => ({
    companyStatus: -1,
    item: {},
    list: {last_page: 0, data: [], total: 0},
    company: [],
    request: {
        page: 1,
        show: 10,
        sortBy: "created_at",
        sorting: "DESC",
        search: null,
    },
    msg: 'Jaringan Bermasalah',
    status: 0
})
const state = initialState
const getters = {
    getItem: state => state.item,
    getList: state => state.list,
    getCompany: state => state.company,
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getCompanyStatus: state => state.companyStatus
}

const actions = {
    async myCompanyStatus({
        commit
    }, url ='mycompany/status-active-event') {
        try {
            var response = await getData(`/${url}`);
            commit('SET_COMPANY_STATUS', response.data)
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async setCompanyStatus({
        commit
    }) {
        commit('SET_COMPANY_STATUS', 1)
    },
    async getCompanyList({
        commit
    }, url = 'company-list') {
        try {
            var response = await getData(`/${url}`);
            commit('SET_COMPANY', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async getListData({
        commit, state
    }, {url, request}) {
        try {
            var response = await getDataWithParams(`/${url}`,request);
            state.request = request
            commit('SET_LIST', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async updateStatus({
        commit
    }, url) {
        try {
            var response = await patchData(`/${url}`);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async submit({
        commit, state
    }, {url, data}) {
        try {
            var response = await postData(`/${url}`,data);
            state.request = {
                page: 1,
                show: 10,
                sortBy: "created_at",
                sorting: "DESC",
                search: null,
            }
            commit('SET_LIST', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async destroy({
        commit, state
    }, url) {
        try {
            var response = await destroyData(`/${url}`);
            state.request = {
                page: 1,
                show: 10,
                sortBy: "created_at",
                sorting: "DESC",
                search: null,
            }
            commit('SET_LIST',response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    }
}

const mutations = {
    SET_COMPANY_STATUS(state,value){
        state.companyStatus = value
    },
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MSG(state, error) {
        if(error.status == 400){
            state.msg = error.data.msg
            state.status = error.data.status
        }else{
            state.msg = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_COMPANY(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.company = response.data
    },
    SET_ITEM(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.item = response.data
    },
    SET_LIST(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.list = response.data
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}